  <template >
   <div class="formPosition" v-role="'func'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-btn style="margin-top:15px;"   fab dark color="primary" :to="(this.$store.state.fromPesquisaFinalista)?'/pesquisa-estudantes-finalistas-por-ano':'pesquisa-geral'">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
      <v-col >
          <h4 style="text-align:center;"> <span> Histórico Académico do Estudante</span></h4>
<div class="text-center">

 <v-container fluid>

    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>
        <v-col class="d-flex" cols="4" sm="4">
             <label v-if="progresso">Carregando os dados , por favor aguarde...</label>

              <v-progress-circular
              v-if="progresso2"
              :size="50"
              color="green"
              indeterminate
            ></v-progress-circular>
            <span v-if="progresso2"  style="font-size:15px;">O certificado abrirá em uma nova janela...Por favor aguarde</span>

        </v-col>

    </v-row>

    <v-row>
        <v-col md="12">
           <img :src="foto" style="width:140px;height:140px;border-radius:10px;">
           <v-btn @click="ShowuploadFotoDialog()" style="margin-left:10px;margin-top:-50px;"   small fab dark color="primary">
                    <v-icon dark small>add_a_photo</v-icon>
                </v-btn>
        </v-col>
    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>


<!-- ********************************************************************************************** -->


<template>
            <v-row justify="center">
              <v-dialog
                v-model="dialogoUpload"
                persistent
                max-width="650px"
              >
                <v-card>
                  <v-card-title style="background-color:#006699;">
                    <span class="text-h5" style="color:white;">Carregar foto </span><br>
                    <!-- <span v-if="isloadingNewPhoto" class="text-h5">Salvar foto</span><br> -->
                  </v-card-title>
                  <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}</div>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="2" md="2" ></v-col>
                        <v-col cols="12" sm="10" md="10" >
                          <v-col md="8" v-if="!isloadingNewPhoto">
                          <div>
                         
                         <input
                              ref="input"
                              type="file"
                              name="image"
                              accept="image/*"
                              @change="setImage"
                            />
                            <div class="content">
                              <section class="cropper-area">
                                <div class="img-cropper">
                                  <vue-cropper v-if="imgSrc !== ''"
                                    ref="cropper"
                                    :aspect-ratio="20 / 20"
                                    :src='imgSrc'
                                    preview=".preview"
                                  />
                                </div>
                              </section>
                              <v-btn v-if="imgSrc !== ''" small @click.prevent="showFileChooser" fab dark color="blue"><v-icon small dark >add_a_photo</v-icon></v-btn>
                            <v-btn v-if="imgSrc !== ''" small @click.prevent="cropImage" fab dark color="#808080"><v-icon small dark >crop</v-icon></v-btn>

                        </div>
                      </div>
                          </v-col>
                          <div v-if="isloadingNewPhoto">
                            <img  :src='cropImg'  ref='image'  width='150px' height='123px'>
                            <v-btn small @click.prevent="showFileChooser" fab dark color="blue"><v-icon dark >add_a_photo</v-icon></v-btn>
                          </div>

              </v-col>
                </v-row>
                      <hr>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red" text @click="cancelarImagem()">Cancelar</v-btn>
                    </v-card-actions>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
          </template>



<!-- ******************************************************************************************************* -->


  <v-col md="4">
    <v-card-text>
      <strong> Dados Pessoais</strong>
       <!-- <v-btn   :disabled="progresso"    v-if="instit ===((this.estudante_dados.length)?(this.estudante_dados[0].instituicao):'') "     color="primary" text  @click="editItem()"><v-icon large color="primary" >edit</v-icon></v-btn> -->

    </v-card-text>
    <hr>
    <v-row>
     <v-col md="12">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Genero:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].sexo):''}}</strong></v-chip>
     </v-col>
     <v-col md="8">
          <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].datanascimento):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Natural de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].provincia):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">BI:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].bi):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip>
     </v-col>
    <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].idMatricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>

        <v-col>

            <v-col md="12">
        <v-chip
              color="pink" style="margin:4px;color:white"
            >
              Instituição Inscrito : {{(this.estudante_dados.length)?(this.estudante_dados[0].instituicao):''}}
            </v-chip>
    </v-col>

        </v-col>

    </v-row>
  </v-col>
  <v-col md="8">
    <v-card>
      <v-card-text>
     <v-tabs
      v-model="tab"
      background-color="#006699"
       center-active
      dark
    >
      <v-tab
        v-for="item in items"
        :key="item"
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        >
         <v-card-text>
          <v-row>
            <v-col md="12"><strong> {{titulo}}</strong></v-col>
            <v-col md="12">
              <v-card>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="this.estudante_dados"
                      >
                    <template v-slot:item.action="{ item }">
                      <v-menu
                      bottom
                      origin="center center"
                      transition="scale-transition"
                      
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          fab dark color="teal"
                          style="color:white"
                          v-on="on"
                          small
                        >
                          <v-icon small>menu</v-icon>
                        </v-btn>
                      </template>
                       <v-list>
                        <v-list-item @click=""><span>Cartão escolar</span></v-list-item>
                        <v-list-item @click=""><span>Boletim</span></v-list-item>
                        <v-list-item @click=""><span>Declaração</span></v-list-item>
                      </v-list>
                      </v-menu>
                    </template>
                  </v-data-table> 
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          
        </v-card-text>
      </v-tab-item>
      <v-tab-item
        >
        <v-card
          color="basil"
          flat
        >
          <v-card-text>{{ text }}</v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        >
        <v-card
          color="basil"
          flat
        >
          <v-card-text>{{ text }}</v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        >
        <v-card
          color="basil"
          flat
        >
          <v-card-text>{{ text }}</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
      </v-card-text>
    </v-card>
 

  </v-col>

</v-row>
  </v-card>
  </v-container>
  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
const ls = require('local-storage')
export default {
  directives: { mask },
  components: {
    VueCropper
  },
  data: () => ({
    formUpdateEstudante: false,
    formUpdateEstudanteKilamba: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    matriculaExistenteResult: null,
    idMatricula: null,
    matricula_actual: '',
    msg_pesquisa: true,
    pesquisa: '',
    estudante: true,
    dialog: false,
    dialogoUpload: false,
     data: null,
    imgSrc: '',
    cropImg: '',
    generateQR: null,
    progresso: false,
    progresso2: false,
    Pessoas: [],
    tab: null,
        items: [
          'Dados académicos', 'Outras informações',
        ],
        text: 'Informação indisponível de momento.',
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'classe' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' },
      { text: 'Ações', value: 'action' },
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],
    overlay: false,
    tab:null,
    datebi: null,
    date: null,
    isloadingNewPhoto: false,
    iskilamba: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    defaultImage:'data:image/png;base64,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',
    foto:null,
    menubi: false,
    habilitaBi: false,
    turmasAll: [],
    mascara: '#########-AA-###',
    resultAlteracao: null,
    turmasAllAno: [],
    turmasFiltered: [],
    municipiosAll: [],
    instituicao_id: ls.get('i_id'),
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      resultado: '',
      fkTurma: '',
      pkInscricao_na_turma: '',
      pkTurma: 0,
      idano_academico: 0,
      anoLectivo: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anoLectivo: ''
    }

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },
    role () {
      return ls.get('role')
    },
    anolectivo () {
      return ls.get('anolectivo')
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    if(!this.$store.state.objaluno){
       //this.$router.push('estudante-pesquisa-geral')
    }else{
       this.foto = (this.$store.state.objaluno.foto === null) ?this.defaultImage:this.$store.state.objaluno.foto
    }
    this.Pesquisar()
    this.initializeCursos()
    this.initializeturmasAll(this.idclasse)
    this.initializeMunicipiosAll()
    this.initializeProvincias()
    this.instit= ls.get('instituicaodescricao')
    if (window.location.host.includes('localhost')) {
      this.iskilamba = true
    } else if (window.location.host.includes('eftsk')) {
      this.iskilamba = true
    } else if (window.location.host.includes('eftsl')) {
      this.iskilamba = false
    }

  },
  methods: {
    teste () {
      console.log(this.estudante_dados)
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },


    cancelarImagem(){
      this.isloadingNewPhoto = false;
      this.dialogoUpload = false;
      this.imgSrc = ''
    },

    async initializeturmasAll (idclasse) {
      try {
        this.overlay = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + idclasse)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

    ShowuploadFotoDialog (){
      this.dialogoUpload = true
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      console.log(this.turmasAll)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },
     cropImage () {
      this.isloadingNewPhoto = true
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      this.savephoto()
    },

    flipX () {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY () {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData () {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData () {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move (offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset () {
      this.$refs.cropper.reset()
      this.cropImg = null
    },
    rotate (deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData () {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData () {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    setImage (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Por favor selecione uma imagem')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Ficheiro não suportado')
      }
    },
    showFileChooser () {
      this.isloadingNewPhoto = false
      this.$refs.input.click()
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async savephoto () {
      try {
        let params = {
          foto: this.cropImg,
          pkPessoa:this.$store.state.objaluno.pkPessoa
        }
        let msg = await axios
          .post('/changefotoPerfil', params)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
            this.dialogoUpload = false
            this.isloadingNewPhoto = false
            this.foto = this.imgSrc
            this.imgSrc =''
            this.dialogoUpload = false
        }
      } catch (error) {

      }
    },

    async  Pesquisar () {
      if (this.$store.state.objaluno !== null) {
        try {
          this.progresso = true
          this.estudante_dados = await axios
            .get('/PesquisaGlobal/' + this.$store.state.objaluno.idMatricula)
            .then(res => res.data)
          this.progresso = false
          if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
        } catch (error) {
          this.progresso = false
        }
      } else {
        this.progresso = false
      }
    },

    async  show_dialogo_transitacao () {
      this.dialog = true
    },

    ImprimirCertificado (item) {
      this.$store.state.objaluno = item
      this.$router.push('preparar-certificado-notas-PesquisaGeral')
    },
    convertDate (dateString) {
      var p = dateString.split('-')
      // eslint-disable-next-line standard/array-bracket-even-spacing
      return [p[2], p[1], p[0] ].join('/')
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      // this.datebi = new Date(date).toISOString().substr(0, 10)
    },

    ShowAlterarProcesso () {
       let item = this.estudante_dados[0]

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
        this.editedItem = Object.assign({}, item)
        this.matricula_actual = this.editedItem.idMatricula
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      //===Faz a verificação se a instituição é kilamba ou não
      //==Caso seja , abre apenas o dialogo do kilamba
      if(this.iskilamba && (this.instituicao_id === 1 || this.instituicao_id === 5)){
        this.formUpdateEstudanteKilamba = true
      }

    },

    editItem () {
      /* this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item) */
      let item = this.estudante_dados[0]

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
        this.editedItem = Object.assign({}, item)
        this.matricula_actual = this.editedItem.idMatricula
        console.log(this.editedItem);
        console.log(this.editedItem.sexo.idSexo == undefined);

      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      //===Faz a verificação se a instituição é kilamba ou não
      //==Caso seja , abre apenas o dialogo do kilamba
       
         this.formUpdateEstudante = true

     
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    close () {
        this.formUpdateEstudante = false
      this.$refs.form.reset()
    },

    closeKilamba (){
      if(this.iskilamba && (this.instituicao_id === 1 || this.instituicao_id === 5))
         this.formUpdateEstudanteKilamba = false
      this.$refs.form.reset()
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          idPEssoa: this.editedItem.bi,
          idMunicipio: this.municSelectedForComb.idMunicipio,
          idPerfil: 1,
          nome: this.editedItem.nome,
          morada: this.editedItem.morada,
          telefone: this.editedItem.telefone,
          autor: ls.get('idPessoa'),
          datanascimento: this.editedItem.datanascimento,
          data_: this.editedItem.data_,
          status_2: this.editedItem.status_2,
          email: this.editedItem.email,
          sexo:  (this.editedItem.sexo.idSexo == undefined) ? this.editedItem.sexo : this.editedItem.sexo.idSexo,
          nomedopai: this.editedItem.nomedopai,
          nomedamae: this.editedItem.nomedamae,
          dataemissaobi: this.editedItem.dataemissaobi,
          bi: this.editedItem.bi,
          ResidenteEm: 1,
          instituicao: ls.get('i_id'),
          instituicaodescricao: this.editedItem.instituicaodescricao,
          curso: this.editedItem.curso,
          turma: this.editedItem.turma,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.idclasse
        }
        try {
          let msg = await axios
            .post('/estudanteInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          // this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })

          try {
            if (msg === 'Inserção ou Actualização feita com sucesso') {
              this.text = ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
              this.estudante_dados[0].nome = this.editedItem.nome
              this.estudante_dados[0].telefone = this.editedItem.telefone
              this.estudante_dados[0].nomedopai = this.editedItem.nomedopai
              this.estudante_dados[0].nomedamae = this.editedItem.nomedamae
              this.estudante_dados[0].datanascimento = this.editedItem.datanascimento
              this.estudante_dados[0].dataemissaobi = this.editedItem.dataemissaobi
              this.estudante_dados[0].bi = this.editedItem.bi
              this.estudante_dados[0].sexo =  (this.editedItem.sexo.idSexo == undefined) ? this.editedItem.sexo : this.editedItem.sexo.idSexo
              this.estudante_dados[0].municipio = this.editedItem.municipio
              this.estudante_dados[0].provincia = this.editedItem.provincia
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          this.progresso = false
        } catch (error) {
          this.isLoading = false
          this.progresso = false
          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } finally {
          this.overlay = false
        }
        if (this.msg === 'Número de Bi ja existente');
        else {
          this.editedItem.nome = ''
          this.editedItem.nomedopai = ''
          this.editedItem.nomedamae = ''
          this.editedItem.datanascimento = ''
          this.editedItem.dataemissaobi = ''
          this.editedItem.bi = ''
          this.editedItem.sexo = ''
          this.editedItem.telefone = ''
          this.editedItem.municipio = ''
          this.editedItem.provincia = ''
          this.$refs.form.resetValidation()
          if (this.editedItem.pkPessoa) {
            this.editedItem.pkPessoa = null
            setTimeout(() => {
              this.close()
            }, 1000)
          }
        }
      }
    },

  async ActualizarProcessoKilamba (){

     this.verificaNProcessoExistente(this.editedItem.idMatricula).then(()=>{
         if(this.matriculaExistenteResult !== null && this.matriculaExistenteResult.length === 0){
           this.ActualizaNumeroProcesso().then(()=>{
               if(this.resultAlteracao.affectedRows >= 0){
                  this.$store.dispatch('textMessage', { 'msg': 'O número de processo alterado com sucesso', 'classMessage': 'msgSucess', 'timeout': 3000 })
                  this.estudante_dados[0].idMatricula = this.editedItem.idMatricula
               }
           });
         }else{
           this.$store.dispatch('textMessage', { 'msg': 'O número de processo fornecido esta sendo usado por um outro estudante', 'classMessage': 'msgError', 'timeout': 3000 })
         }
     })

  },

  async verificaNProcessoExistente (processo){
      try {
          this.overlay = true
          this.matriculaExistenteResult = await axios
            .get('/verificaNProcessoExistente/'+ processo)
            .then(res => res.data)
          this.overlay = false
           
        } catch (error) {
          this.overlay = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
  },

  async ActualizaNumeroProcesso (){


        var params = {
          matricula_actual: this.matricula_actual,
          matricula_nova: this.editedItem.idMatricula,
          anolectivo: this.anolectivo
         
        }
        try {
          this.overlay = true
          this.resultAlteracao = await axios
            .post('/ActualizarNumeroProcessoKilamba', params)
            .then(res => res.data)
          this.overlay = false
        } catch (error) {
          this.overlay = false

          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } 
    

  },

    async Insert_UpdateTransitacao () {
      /* let params =
        {
          idMatricula: this.estudante_dados[0].idMatricula,
          anoLectivo: this.estudante_dados[0].anoLectivo,
          idAno_Academico: this.estudante_dados[0].idAno_Academico,
          fkPessoa: this.estudante_dados[0].pkPessoa
        } */
    }

  }

}

</script>
